'use client'

import { motion, useReducedMotion } from 'framer-motion'
import { FC, ReactNode } from 'react'

type RevealProps = {
  children: ReactNode
  className?: string
  delay?: number
  y?: number
}

// Scroll-Reveal für die Projekt-Detailseite: einmaliges, weiches Einblenden
// beim Erreichen des Viewports. Respektiert prefers-reduced-motion.
const Reveal: FC<RevealProps> = ({ children, className, delay = 0, y = 32 }) => {
  const reduceMotion = useReducedMotion()

  if (reduceMotion) {
    return <div className={className}>{children}</div>
  }

  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: '-80px' }}
      transition={{ duration: 0.7, delay, ease: [0.21, 0.6, 0.35, 1] }}
    >
      {children}
    </motion.div>
  )
}

export default Reveal
